export enum ItemState {
    uploading = 'Uploading',
    uploaded = 'Uploaded',
}
export const StorageError = {canceled: 'storage/canceled'};
